import React, { forwardRef, useRef } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import { clutch } from "../../utils/number/number";
import { TRACK_SIZES } from "./Progress.constans";

import styles from "./Progress.module.scss";

const Progress = forwardRef(
  (
    {
      value, min, max,
      className, thumbClassName, progressClassName, trackClassName,
      disabled,
      thumbProps, showThumb, size,
      ...restProps
    },
    ref
  ) => {
    const sliderRef = useRef(null);
    const thumbRef = useRef(null);

    let currentProgressInPercents;

    const valueClutched = clutch(value, min, max);

    if (valueClutched === min) {
      currentProgressInPercents = 0;
    } else if (valueClutched === max) {
      currentProgressInPercents = 100;
    } else {
      currentProgressInPercents = ((valueClutched - min) * 100) / (max - min);
    }

    const currentProgressWithPercentSymbol = `${currentProgressInPercents}%`;
    const rootClassName = classnames(styles["root"], className, {
      [styles["disabled"]]: disabled,
      "disabled": disabled,
    });

    return (
      <div
        {...restProps}
        className={rootClassName}
        ref={ref || sliderRef}
      >
        <div className={classnames(styles["track"], trackClassName, styles[size])}>
          <div
            className={classnames(styles["progress"], progressClassName)}
            style={{
              width: currentProgressWithPercentSymbol
            }}
          />
          {
            showThumb && (
              <div
                ref={thumbRef}
                className={classnames(styles["thumb"], thumbClassName)}
                style={{
                  left: currentProgressWithPercentSymbol
                }}
                tabIndex="0"
                role="slider"
                aria-orientation="horizontal"
                aria-valuemax={max}
                aria-valuemin={min}
                aria-valuenow={value}
                {...thumbProps}
              />
            )
          }
        </div>
      </div>
    );
  }
);

Progress.defaultProps = {
  min: 0,
  max: 100,
  size: TRACK_SIZES.sm
};

Progress.propTypes = {
  showThumb: PropTypes.bool,
  disabled: PropTypes.bool,

  value: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,

  className: PropTypes.string,
  thumbClassName: PropTypes.string,
  progressClassName: PropTypes.string,
  thumbProps: PropTypes.object,
  size: PropTypes.oneOf(Object.values(TRACK_SIZES)),
};

export default Progress;
